export const APP_ROLES = {
  Admin: "Admin",
  MarketAccess: "MarketAccess",
  ComplianceLegal: "ComplianceLegal",
  Risk: "Risk",
  Treasury: "Treasury",
  Finance: "Finance",
  Technology: "Technology"
} as const;

export type AppRole = (typeof APP_ROLES)[keyof typeof APP_ROLES];

export type LifecycleName =
  | "marketaccess"
  | "compliance"
  | "legal"
  | "risk"
  | "creditrisk"
  | "treasury"
  | "finance"
  | "tech";

export const LIFECYCLE_LABELS: Record<LifecycleName, string> = {
  marketaccess: "Market Access",
  compliance: "Compliance",
  legal: "Legal",
  risk: "Risk",
  creditrisk: "Credit Risk",
  treasury: "Treasury",
  finance: "Finance",
  tech: "Technology"
};

export const LIFECYCLE_ACCESS_ROLES: Record<LifecycleName, AppRole> = {
  marketaccess: APP_ROLES.MarketAccess,
  compliance: APP_ROLES.ComplianceLegal,
  legal: APP_ROLES.ComplianceLegal,
  risk: APP_ROLES.Risk,
  // Split out of Risk and worked by the same people, so the same role.
  creditrisk: APP_ROLES.Risk,
  treasury: APP_ROLES.Treasury,
  finance: APP_ROLES.Finance,
  tech: APP_ROLES.Technology
};

export const ALL_APP_ROLES = Object.values(APP_ROLES);
